import { NavLink, useLocation } from "react-router-dom";
import React from 'react';
import { Tooltip } from '@mui/material';
import "../css/sidemenu.css"

// Active state comes from the current URL, so it survives page reloads and
// direct links (it used to live in local state and reset to Dashboard).
const SideItem = ({ title, icons, icononly, label }) => {
    const { pathname } = useLocation();
    const isRoot = pathname === '/' && title === 'Dashboard';

    const item = <NavLink
        to={"/" + title}
        className={({ isActive }) => (isActive || isRoot) ? "sideitem active" : "sideitem"}
    >
        <span className="sideicon">{icons}</span>
        {icononly ? <span className="sidelabel">{label}</span> : <></>}
    </NavLink>

    // Tooltip clones its child's className, which would clobber NavLink's
    // function-form className, so it wraps a plain div instead.
    return icononly ? item : <Tooltip title={label} placement="right" arrow><div>{item}</div></Tooltip>
}

export default SideItem;
